// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import {
    API_ROOT
} from './util/config' //自动获取IP
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
axios.defaults.baseURL = API_ROOT
axios.defaults.withCredentials = true
axios.defaults.baseURL = API_ROOT ? API_ROOT : (location.origin + '/nausf-auth/'); //自动获取IP

/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
        // components: {
        //   App
        // },
        // template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js